import React from 'react'

export default function Erro404() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 items-center mb-20">
   
    <main className="mt-5 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-8 lg:mt-10 lg:px-8 xl:mt-18">
             <div className="sm:text-center ">
               <h1 className="text-6xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-8xl">
                 <span className="block xl:inline">:( Erro404</span>{' '}
                 <span className="block text-cyan-600 xl:inline">¡Opp!</span>
               </h1>           
           
             </div>
           </main>
   
     </div>
  )
}
